module.exports = __webpack_public_path__ + "img/parttwo_pic5.4222a36b.png";